import React, { useEffect } from "react";
import Awareness from "../pages/Awareness";
import { ApiName } from "../Constant/ApiName";
import { fetchApiGet } from "../utils/FetchApi";
import tagManagerEvents from "../utils/GoogleTagManager";
import { setCookie } from "../utils/CommonFunction";

type Props = {
  jwtToken: string | null;
};

const AwarenessScreen = (props: Props) => {
  useEffect(() => {
    if (props.jwtToken != null) {
      handleUtmGet();
    }
  }, [props.jwtToken]);

  const handleUtmGet = () => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const utmSource: string | null = searchParams.get("utm_source");

    handleGetFlow(utmSource);
  };

  const handleGetFlow = async (_utm: string | null) => {
    try {
      let endPoint = `${ApiName.awarenessFLow}?utm_source=${_utm}`;
      let response = await fetchApiGet(props.jwtToken, endPoint);

      if (response.response.code === "0" && response.status === 200) {
        tagManagerEvents("SUBSCRIBE", "econTikTok");
        let url = window.location.origin;
        let _package = "";
        if (response.response.package.toLowerCase() === "postpaid") {
          _package = "postpaid";
        } else {
          _package = "prepaid";
        }
        setCookie(
          response.response.msisdn,
          _package,
          response.response.sessionid
        );

        url = `${url}/home`;

        if (url.includes("http:")) {
          url = url.replace("http", "https");
        }
        window.location.replace(url);
      } else if (response.response.code === "1" && response.status === 200) {
        let url = window.location.origin;
        let _package = "";
        if (response.response.package.toLowerCase() === "postpaid") {
          _package = "postpaid";
        } else {
          _package = "prepaid";
        }
        setCookie(
          response.response.msisdn,
          _package,
          response.response.sessionid
        );

        url = `${url}/home`;

        if (url.includes("http:")) {
          url = url.replace("http", "https");
        }
        window.location.replace(url);
      } else {
        tagManagerEvents("SUBSCRIBE_FAIL", _utm);
        navigateToHome("");
      }
    } catch (error) {
      navigateToHome("");
      console.log("get flow error" + error);
    }
  };

  const navigateToHome = (msisdn: any) => {
    let url = window.location.origin;
    url = `${url}/landing`;
    window.location.replace(url);
  };
  return <Awareness />;
};

export default AwarenessScreen;
